/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shipping_Quote_UnavailableInputs */

const vi_error_shipping_quote_unavailable = /** @type {(inputs: Error_Shipping_Quote_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa lấy được phí ship từ Viettel Post (đang tắt hoặc lỗi). Thử lại sau.`)
};

/**

* @param {Error_Shipping_Quote_UnavailableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shipping_quote_unavailable = /** @type {((inputs?: Error_Shipping_Quote_UnavailableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shipping_Quote_UnavailableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shipping_quote_unavailable(inputs)
});